const fadeIn = (el, timeout, display) => {
    el.style.opacity = 0;
    el.style.display = display || 'block';
    el.style.transition = `opacity ${timeout}ms`;
    setTimeout(() => {
        el.style.opacity = 1;
    }, 10);
};


export default function courseContent() {
    let _block = document.querySelector('#course-1');
    fadeIn(_block, 1000, 'flex');
    
    $(".course-content .nav-tabs").on('click', 'a', function (e) {
        e.preventDefault();
        $('.course-content .tab-button').removeClass('active');
        $(this).addClass('active');
        var _id = $(this).attr('href');
        
        $('.course-content__body').hide();

        _block = document.querySelector(_id);
        fadeIn(_block, 1000, 'flex');
               
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/courseContent.js